// removed by extract-text-webpack-plugin
module.exports = {"body":"src-components-complex-About----style-module---body---F0sgI"};


//////////////////
// WEBPACK FOOTER
// ./src/components/complex/About/style.module.css
// module id = 234
// module chunks = 263791100135453